export function ActorNewIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_212_4107)">
        <path d="M14.5834 4.54626C15.1467 5.63336 16.0325 6.51985 17.1195 7.08337C16.0328 7.64677 15.1468 8.53277 14.5834 9.61951C14.0198 8.53251 13.1334 7.64675 12.0463 7.08337C13.1336 6.51986 14.0199 5.63361 14.5834 4.54626Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
        <path d="M10.0001 12.5C7.36329 12.5 5.04429 13.8607 3.70701 15.9183C3.2369 16.6417 3.83179 17.5 4.69447 17.5H15.3058C16.1684 17.5 16.7633 16.6417 16.2932 15.9183C14.9559 13.8607 12.6369 12.5 10.0001 12.5Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" />
        <path d="M11.6666 3.77931C11.1763 3.4957 10.6071 3.33337 9.99996 3.33337C8.15901 3.33337 6.66663 4.82576 6.66663 6.66671C6.66663 8.50766 8.15901 10 9.99996 10C10.2877 10 10.5669 9.96358 10.8333 9.89503" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_212_4107">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "ActorNewIcon";
